// ▶ Busca automatica de endereco por CEP (spec 2026-09-17). ViaCEP: publica,
// gratuita, sem chave. Mesma regra do buscarCnpj.ts: nunca lanca.
export interface CepEncontrado {
  endereco: string | null
  bairro: string | null
  municipio: string | null
  uf: string | null
}

function textoOuNulo(valor: unknown): string | null {
  return typeof valor === 'string' && valor !== '' ? valor : null
}

export function interpretarRespostaViaCep(json: unknown): CepEncontrado | null {
  if (typeof json !== 'object' || json === null) return null
  const j = json as Record<string, unknown>
  if (j.erro === true) return null
  return {
    endereco: textoOuNulo(j.logradouro),
    bairro: textoOuNulo(j.bairro),
    municipio: textoOuNulo(j.localidade),
    uf: textoOuNulo(j.uf),
  }
}

export async function buscarCep(cep: string): Promise<CepEncontrado | null> {
  const limpo = cep.replace(/\D/g, '')
  if (limpo.length !== 8) return null
  try {
    const resposta = await fetch(`https://viacep.com.br/ws/${limpo}/json/`, {
      signal: AbortSignal.timeout(8000),
    })
    if (!resposta.ok) return null
    return interpretarRespostaViaCep(await resposta.json())
  } catch {
    return null
  }
}
